import type { RouteRecordRaw } from 'vue-router'
import InvestList from '@/views/middleGround/invest/investList.vue'
import InvestDetail from '@/views/middleGround/invest/investDetail.vue'
import InvestApplyList from '@/views/middleGround/invest/investApplyList.vue'
import InvestReviewedDetail from '@/views/middleGround/invest/investReviewedDetail.vue'
import InvestWillAuditApplyList from '@/views/middleGround/invest/investWillAuditApplyList.vue'
import InvestWillAuditApplyDetail from '@/views/middleGround/invest/investWillAuditApplyDetail.vue'
import InvestStat from '@/views/middleGround/invest/investStat.vue'

// 招商活动
export const InvestRoute: Array<RouteRecordRaw> = [
  {
    path: 'invest/investList',
    name: 'InvestList',
    meta: {
      title: '招商活动-项目列表' 
    },
    component: InvestList
  },
  {
    path: 'invest/investList/investDetail/:id',
    name: 'InvestDetail',
    meta: {
      title: '招商活动-项目详情' 
    },
    component: InvestDetail
  },
  {
    path: 'invest/investApplyList',
    name: 'InvestApplyList',
    meta: {
      title: '招商活动-报名列表' 
    },
    component: InvestApplyList
  },
  {
    path: 'invest/investApplyList/investReviewedDetail/:id',
    name: 'InvestReviewedDetail',
    meta: {
      title: '招商活动-报名详情' 
    },
    component: InvestReviewedDetail
  },
  {
    path: 'invest/investWillAuditApplyList',
    name: 'InvestWillAuditApplyList',
    meta: {
      title: '招商活动-待审核的报名' 
    },
    component: InvestWillAuditApplyList
  },
  {
    path: 'invest/investWillAuditApplyList/investWillAuditApplyDetail/:id',
    name: 'InvestWillAuditApplyDetail',
    meta: {
      title: '招商活动-待审核的报名' 
    },
    component: InvestWillAuditApplyDetail
  },
  {
    path: 'invest/investStat',
    name: 'InvestStat',
    meta: {
      title: '招商活动-统计' 
    },
    component: InvestStat
  },
]

export default InvestRoute